import { OdataManager } from '@/api/odata/odata-manager';
import { WorkType } from '@/api/model/interfaces';

export default class WorkTypeOdata extends OdataManager<WorkType> {}
